<template>
  <div>
    <h1>{{ tituloh1 }}</h1>
    <p class="alert alert-info">Cada firmante del documento debe ser configurado convenientemente para el correcto funcionamiento del proceso de firma electrónica; eso es, indicando el tipo de firma (manuscrita o con certificado digital), la posición que ocupa dentro del documento, etc. <strong>Solo podrás continuar cuando todos los firmantes del documento estén correctamente definidos.</strong></p>
    <div v-if="ubicacionfirmaseditada">
      <div v-if="!firmanteactivo">
        <b-row class="my-3">
          <b-col cols="12">
            <b-row>
              <b-col cols="4" v-for="(atrfir, index) in atributosfirmantes" :key="'atrfir' + index">
                <div class="py-2 px-3 m-2 border rounded">
                  <h3>{{ atrfir.nombre }}</h3>
                  <b-row>
                    <b-col>
                      <b-card-text><strong>Tipo firma electrónica</strong><br />{{ atrfir.modofirma }}</b-card-text>
                      <b-card-text><strong>Sello de empresa</strong><br />{{ atrfir.esexterno ? '- no procede -' : atrfir.selloempresa }}</b-card-text>
                      <b-card-text v-if="ubicacionfirmaseditada === 'endocumento'"> <strong>Posición de la firma</strong><br />{{ !atrfir.posicionfirma.definida ? 'No definida' : 'Pág.: ' + atrfir.posicionfirma.pagina }} </b-card-text>
                      <b-button class="bgcolor-manusa" @click="editarfirmante(atrfir)">Editar atributos</b-button>
                    </b-col>
                    <b-col cols="3">
                      <b-icon v-if="!atrfir.efirmadefinida" icon="exclamation-circle" style="color: red; width: 100%; height: auto"></b-icon>
                      <b-icon v-else icon="check2-circle" style="color: green; width: 100%; height: auto"></b-icon>
                    </b-col>
                  </b-row>
                </div>
              </b-col>
            </b-row>
          </b-col>
        </b-row>

        <div class="w-100 d-flex justify-content-between mb-4">
          <b-button @click="pasoatras" variant="danger">
            <b-icon-arrow-left-circle-fill></b-icon-arrow-left-circle-fill>
            Atrás
          </b-button>
          <div v-if="!firmantesok" class="alert alert-warning py-2 m-0" style="color: red; font-weight: bold">
            ¡Atención! No podrás continuar mientras haya algún firmante con este símbolo:
            <b-icon icon="exclamation-circle" font-scale="1.5"></b-icon>
          </div>
          <b-button :disabled="!firmantesok" @click="siguientepaso" class="bgcolor-manusa">
            Siguiente
            <b-icon-arrow-right-circle-fill></b-icon-arrow-right-circle-fill>
          </b-button>
        </div>

        <div class="my-5 text-center w-100">
          <h4>Previsualización del resultado</h4>
          <div class="text-left w-75 m-auto">
            Aquí podrás revisar cómo quedará el documento que se enviará a firmar<br />
            Notas:
            <ul>
              <li>Las <strong style="color: red">X rojas</strong> solo representan la ubicación final de las <strong>firmas manuscritas</strong>; en el documento final estas marcas desaparecerán.</li>
              <li>Los textos en gris que aparecen en el bloque de firma tales como <strong style="color: gray">FIRMANTE1IMAGEN, FIRMANTE2IMAGEN</strong>, etc., son marcas especiales que quedarán ocultos en documento final</li>
            </ul>
          </div>
          <AbrirPDF v-if="pdfprocesado.length" :src="pdfprocesado"></AbrirPDF>
        </div>
      </div>
      <div v-else>
        <div v-if="ubicacionfirmaseditada === 'ultimapagina'">
          <DefinicionCaracteristicasDeFirmantesUltimaPagina :firmante="firmanteactivo" :pdfdoc="pdfdoc" v-on:cancelar-edicion="onCancelarEdicion" v-on:guardar-cambios-edicion="onGuardarCambiosEdicion"></DefinicionCaracteristicasDeFirmantesUltimaPagina>
        </div>
        <div v-else>
          <DefinicionCaracteristicasDeFirmantesEnDocumento :firmante="firmanteactivo" :pdfdoc="pdfdoc" v-on:cancelar-edicion="onCancelarEdicion" v-on:guardar-cambios-edicion="onGuardarCambiosEdicion"></DefinicionCaracteristicasDeFirmantesEnDocumento>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="w-75 m-auto">
        <h3 class="mt-5">¿Dónde se ubicarán las firmas en el documento?</h3>
        <div class="alert alert-info">El documento original se va a ver alterado en el momento en que se firme; lo que ahora se va a determinar es qué modalidad se empleará para ubicar la posición de las firmas. Hay dos opciones y debes seleccionar una.<br /></div>
        <b-card-group deck>
          <b-card align="center" title="Dentro del propio documento">
            <b-card-text>
              <p>Esta modalidad determina que las firmas se ubicarán <strong>en alguna de las páginas existentes</strong> del propio documento.</p>
              <p>Implica que deberás definir <strong>manualmente</strong> la página y posición de cada una de las firmas</p>
              <p class="font-italic">Normalmente es el método usado cuando el documento a firmar proviene de otra entidad y se está sujeto a las indicaciones por ella dictadas.</p>
            </b-card-text>
            <b-button @click="ubicacionfirmaseditada = 'endocumento'" class="bgcolor-manusa"> Seleccionar </b-button>
          </b-card>
          <b-card align="center" title="Crear una página nueva al final">
            <b-card-text>
              <p>Esta modalidad es sin duda la más rápida; Se <strong>añadirá una última página al documento original</strong> y se distribuirán en ella <strong>automáticamente</strong> todas las firmas</p>
              <p class="font-italic">Normalmente este método es apropiado cuando el documento es creado internamente (p.e. un acta, un contrato de servicio, etc.)</p>
            </b-card-text>
            <b-button @click="ubicacionfirmaseditada = 'ultimapagina'" class="bgcolor-manusa"> Seleccionar </b-button>
          </b-card>
        </b-card-group>
      </div>
    </div>
  </div>
</template>

<script>
import AbrirPDF from '@/components/AbrirPDF.vue';
import DefinicionCaracteristicasDeFirmantesUltimaPagina from '@/components/DefinicionCaracteristicasDeFirmantesUltimaPagina.vue';
import DefinicionCaracteristicasDeFirmantesEnDocumento from '@/components/DefinicionCaracteristicasDeFirmantesEnDocumento.vue';
export default {
  components: {
    AbrirPDF,
    DefinicionCaracteristicasDeFirmantesUltimaPagina,
    DefinicionCaracteristicasDeFirmantesEnDocumento
  },
  props: {
    tituloh1: {
      type: String,
      default: 'Definición de las características de las efirmas'
    },
    ubicacionfirmas: String,
    firmantes: Array,
    pdfdoc: String
  },
  data() {
    return {
      atributosfirmantes: [],
      firmanteactivo: null,
      firmantesok: false,
      pdfprocesado: '',
      ubicacionfirmaseditada: ''
    };
  },
  mounted() {
    this.ubicacionfirmaseditada = this.ubicacionfirmas;

    console.log('firmantes', this.firmantes);
    // se cargan los firmantes y se actualizan sus atributos
    this.firmantes.forEach((f, index) => {
      if (!f.id) {
        const atrfir = {
          id: index + 1,
          nombre: f.nombre,
          email: f.email,
          empresa: f.empresa,
          cargo: f.cargo,
          efirmadefinida: false,
          esexterno: false,
          modofirma: 'manuscrita',
          selloempresa: 'sinsello',
          posicionfirma: {
            definida: false,
            pagina: 0,
            top: 0,
            left: 0,
            width: 0,
            height: 0
          },
          piefirma: {
            activado: false,
            linea1: f.nombre,
            linea2: f.cargo,
            linea3: ''
          }
        };
        this.actualizaratributosfirmante(atrfir);
        this.atributosfirmantes.push(atrfir);
      } else {
        this.actualizaratributosfirmante(f);
        this.atributosfirmantes.push(f);
      }
    });
    this.actualizarfirmantesok();
    this.actualizarpdfprocesado();
  },
  methods: {
    textorepresentacionsegunsello: function (selloempresa) {
      if (selloempresa === 'sinsello') return '';
      const mcde = this.$store.getters.misCertificadosDeEmpresa.filter((c) => c.sello === selloempresa)[0];
      return 'en representación de ' + mcde.nombre;
    },
    actualizaratributosfirmante(atrfir) {
      atrfir.efirmadefinida = (this.ubicacionfirmaseditada === 'endocumento' && atrfir.posicionfirma.definida) || this.ubicacionfirmaseditada === 'ultimapagina';
      atrfir.esexterno = atrfir.email.split('@')[1] !== 'manusa.com';
      //atrfir.piefirma.linea3 = this.textorepresentacionsegunsello(atrfir.selloempresa);
    },
    actualizarfirmantesok() {
      var efirmadefinida = true;
      this.atributosfirmantes.forEach((atrfir) => {
        efirmadefinida &= atrfir.efirmadefinida;
      });
      this.firmantesok = efirmadefinida;
    },
    actualizarpdfprocesado() {
      if (this.ubicacionfirmaseditada) {
        var _t = this;
        const params = {
          accion: 'procesar-pdf-segun-firmantes-' + this.ubicacionfirmaseditada,
          datapdf: this.pdfdoc,
          atributosfirmantes: this.atributosfirmantes
        };
        console.log('actualizarpdfprocesado', this.atributosfirmantes);
        this.axios
          .post('/efirma/accion', params, {
            headers: {
              Authorization: `Bearer ${process.env.VUE_APP_CLAVEAPIEFIRMA}`
            }
          })
          .then(function (response) {
            console.log('leftmm', response.data.leftmm);
            console.log('atributosfirmantes', response.data.atributosfirmantes);
            _t.pdfprocesado = 'data:application/pdf;base64,' + response.data.srcpdfprocesado;
          });
      }
    },
    editarfirmante(f) {
      console.log('editarfirmante - firmante:', f);
      this.firmanteactivo = f;
    },
    siguientepaso() {
      this.$emit('atributos-firmantes-definidos', this.ubicacionfirmaseditada, this.atributosfirmantes);
    },
    pasoatras() {
      this.$emit('paso-atras');
    },
    onGuardarCambiosEdicion: function (atrfir) {
      console.log(atrfir);
      this.actualizaratributosfirmante(atrfir);
      for (let index = 0; index < this.atributosfirmantes.length; index++) {
        if (this.atributosfirmantes[index].id === atrfir.id) {
          this.atributosfirmantes[index] = atrfir;
          break;
        }
      }
      this.actualizarfirmantesok();
      this.actualizarpdfprocesado();
      this.firmanteactivo = null;
    },
    onCancelarEdicion: function (datos) {
      console.log(datos);
      this.firmanteactivo = null;
    }
  }
};
</script>
